<div class="container">
  <h1 class="title">{{'locker.category.title'|traduccion}}</h1>

  <button mat-raised-button color="primary" (click)="openNew()"><mat-icon>add</mat-icon></button>

  <div class="table-container">
    <app-data-table
      [dataSource]="dataSource"
      [displayedColumns]="displayedColumns"
      [emptyMessage]="'No hay categorias disponibles.'"
      [rowClickable]="true"
      [rowClass]="categoryRowClass"
      (rowClick)="openDetails($event.row)">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>{{'locker.category.table.header.id'|traduccion}}</th>
        <td mat-cell *matCellDef="let element">{{ element.id }}</td>
      </ng-container>

      <ng-container matColumnDef="parentId">
        <th mat-header-cell *matHeaderCellDef>{{'locker.category.table.header.parentId'|traduccion}}</th>
        <td mat-cell *matCellDef="let element">
          <div class="category-parent-cell">
            <span class="category-parent-badge" [class.category-parent-badge--root]="element.parentId == null">
              {{ getParentCategoryLabel(element) }}
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef>{{'locker.category.table.header.code'|traduccion}}</th>
        <td mat-cell *matCellDef="let element">
          <div class="category-code-cell" [style.padding-left]="buildIndent(getCategoryLevel(element))">
            <span class="category-branch" *ngIf="getCategoryLevel(element) > 0">↳</span>
            <span class="category-code">{{ element.code }}</span>
          </div>
        </td>
      </ng-container>
    </app-data-table>
  </div>
</div>
